import * as z from 'zod/mini';
import { BirthDateInput } from './BirthDateInput.js';
import { BloodPressureInput } from './BloodPressureInput.js';
import { GenderInput } from './GenderInput.js';
import { MeasurementInput } from './MeasurementInput.js';
import { MultiSelectInput } from './MultiSelectInput.js';
import { ScaleInput } from './ScaleInput.js';
import { SingleSelectInput } from './SingleSelectInput.js';
import { TextInput } from './TextInput.js';
export const FormInputs = [
    BirthDateInput,
    BloodPressureInput,
    GenderInput,
    MeasurementInput,
    MultiSelectInput,
    ScaleInput,
    SingleSelectInput,
    TextInput,
];
export const FormInputConfig = z.discriminatedUnion('type', [
    BirthDateInput.input,
    BloodPressureInput.input,
    GenderInput.input,
    MeasurementInput.input,
    MultiSelectInput.input,
    ScaleInput.input,
    SingleSelectInput.input,
    TextInput.input,
]);
export const FormInputValue = z.discriminatedUnion('type', [
    BirthDateInput.value,
    BloodPressureInput.value,
    GenderInput.value,
    MeasurementInput.value,
    MultiSelectInput.value,
    ScaleInput.value,
    SingleSelectInput.value,
    TextInput.value,
]);
//# sourceMappingURL=FormInput.js.map